import React from 'react';
import { localization } from '../../localization';
import { ImgCollection, languageKeyList, LanguageKeys, Settings } from '../../CommonTypes';
import { FAButton, NumberInput } from '../coreui/basic';
import { CollapsibleContainer, clamp } from '../coreui';
import { SPOpenImgStyled, SettingsPaneStyled, SPGeneralStyled } from './SettingsPane.styles';

export interface ISettingsPaneProps {
  onSettingsReset: () => void;
  onSettingsChanged: (newSettings: Settings) => void;
  onOpenImage: (cat: number, external?: boolean) => void;

  collection: ImgCollection;
  allowExternalSrc: boolean;
}

export interface ISettingsPaneState {
  generalOpen: boolean;
  openImgOpen: boolean;
}

export class SettingsPane extends React.Component<Settings & ISettingsPaneProps, ISettingsPaneState> {
  constructor(props: Settings & ISettingsPaneProps) {
    super(props);

    this.state = {
      generalOpen: false,
      openImgOpen: false
    }
  }

  public render() {
    const loc = localization[this.props.lang];

    const OpenImg = (
      <CollapsibleContainer name={ loc.settings.openImage }
        onTitleBarClick={() => this.setState(prev => ({ generalOpen: !prev.generalOpen }))}
        collapsed={this.state.generalOpen} transitionDuration={this.props.transitionDuration} titleExtra={
          <FAButton icon='images' size={35} onClick={() => this.props.onOpenImage(-1)} data-tip={loc.tooltips.openImage}/>
      }>
        <SPOpenImgStyled>
          {this.props.collection.categories.map((cat, i) => (
            <React.Fragment key={cat.key}>
              <span>{cat.name[this.props.lang]}</span>
              <FAButton icon='images' onClick={() => this.props.onOpenImage(i)}
                data-tip={loc.tooltips.openImageCateg(cat.name[this.props.lang])} />
            </React.Fragment>
          ))}
          {this.props.allowExternalSrc ? <>
            <span>{ loc.external }</span>
            <FAButton icon='images' onClick={() => this.props.onOpenImage(-1, true) }
                data-tip={loc.tooltips.openImageCateg(loc.external)}/>
          </> : null }
        </SPOpenImgStyled>
      </CollapsibleContainer>
    );

    const General = (
      <CollapsibleContainer name={ loc.settings.general } openHeight={{ type: 'height', value: 140 }}
        onTitleBarClick={() => this.setState(prev => ({ openImgOpen: !prev.openImgOpen }))}
        collapsed={this.state.openImgOpen} transitionDuration={this.props.transitionDuration} titleExtra={
          <FAButton icon='undo' size={35} onClick={this.props.onSettingsReset} data-tip={loc.tooltips.resetSettings}/>
      }>
        <SPGeneralStyled>
          <span>{loc.settings.languageHeader}</span>
          <select value={this.props.lang} onChange={e => this.props.onSettingsChanged({ transitionDuration: this.props.transitionDuration, lang: e.currentTarget.value as LanguageKeys })}>
            {languageKeyList.map(lang => (
              <option value={lang} key={lang}>
                { localization[lang as LanguageKeys].settings.languageName}
              </option>
            ))}
          </select>
          <span>{loc.settings.animDur}</span>
          <NumberInput value={this.props.transitionDuration} step={0.1} decimals={1} onChange={() => { }}
            onBlur={e => this.props.onSettingsChanged({ lang: this.props.lang, transitionDuration: clamp(parseFloat(e.currentTarget.value), 0, 4) || 0 })} />
          <span>s</span>
        </SPGeneralStyled>
      </CollapsibleContainer>
    );

    return (
      <SettingsPaneStyled>
        { General }
        
        { OpenImg }
      </SettingsPaneStyled>
    );
  }
}
